// extracted by mini-css-extract-plugin
module.exports = {"sideNavigationBar":"SideNavigationBar_sideNavigationBar__39uXb"};